export const JUNO_COLLECTIONS_ERROR_MODIFY_RESERVED_COLLECTION =
  'juno.collections.error.modify_reserved_collection';
export const JUNO_COLLECTIONS_ERROR_RESERVED_NAME = 'juno.collections.error.reserved_name';
export const JUNO_COLLECTIONS_ERROR_RESERVED_COLLECTION =
  'juno.collections.error.reserved_collection';
export const JUNO_COLLECTIONS_ERROR_RATE_CONFIG_ENABLED =
  'juno.collections.error.rate_config_enabled';
export const JUNO_COLLECTIONS_ERROR_DELETE_PREFIX_RESERVED =
  'juno.collections.error.prefix_deletion';
export const JUNO_COLLECTIONS_ERROR_COLLECTION_NOT_EMPTY = 'juno.collections.error.not_empty';
export const JUNO_COLLECTIONS_ERROR_COLLECTION_NOT_FOUND = 'juno.collections.error.not_found';
export const JUNO_COLLECTIONS_ERROR_PREFIX_RESERVED = 'juno.collections.error.prefix_reserved';
